module.exports = __webpack_public_path__ + "images/places/training_693-c14e8eba41f2e0835717fede9d0072b4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_693.jpg
 ** module id = 325
 ** module chunks = 0
 **/